import {Component} from '@angular/core';
import {RegistrationService} from "../../../services/registration.service";
import {
  AbstractControl, FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {DetailsMapModel} from "../../../models/registration/detailsMap.model";
import {countryData, currencyData} from "../reg-modal/reg-step2/data";
import {GoogleAnalyticsService} from "ngx-google-analytics";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {AuthService} from "../../../services/auth.service";
import {ConfigService} from "../../../services/config.service";
import {ModalService} from "../../../services/modal.service";

@Component({
  selector: 'app-min-reg-modal',
  templateUrl: './min-reg-modal.component.html',
  styleUrls: ['./min-reg-modal.component.scss']
})

export class MinRegModalComponent {
  /** the minimal registration form
   // required data: email, username, password + country, currency
   // we require: birthdate, agreeTerms
   TODO: add optional fields
   // optional fields: address, city, province, zip code, security quuestion-answer, first-lastname, phone
   */


  minRegForm!: UntypedFormGroup;
  regSubmit: boolean = false;
  isLoading: boolean = false;
  // // regSubs?: Subscription; //we dont need regObject because we dont save data between the steps or the user refreshes the browser during filling the form
  // // regObject?: RegdataModel | null;

  //password show or hide
  fieldTextType!: boolean;

  //birth date string
  currentYear = new Date().getFullYear();
  startYear = 1900;
  yearOptions: number[] = [];
  monthOptions: string[] = [];
  dayOptions: number[] = [];
  formSubs?: Subscription;
  previousBirthYear: number | null = null;
  previousBirthMonth: number | null = null;

  minimalAge: number;

  countryOptions: {name: string, code: string}[] = [];
  currencyOptions: {name: string, code: string}[] = [];

  //
  // showOptionalFields: boolean = false;

  // provinceOptions: {name: string, code: string}[] = [];
  // subdivisions: {country_code: string, subdivision_name: string, "code": string}[] = []
  // previousCountry: string = "";



  currentStep: string = 'form';

  agreeTerms = new FormControl(false);

  login: string | null = null;
  pw: string | null = null;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private regService: RegistrationService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private gaService: GoogleAnalyticsService,
    private trackingService: TrackingHelperService,
    private authService: AuthService,
    private configService: ConfigService,
    private modalService: ModalService
  ) {
    this.minimalAge = this.configService.minAgeAtReg;

    for (let year = this.currentYear-this.minimalAge; year >= this.startYear; year--) {
      this.yearOptions.push(year)
    }
    for (let i = 1; i<= 12; i++) {
      const month = i<10 ? `0${i}` : `${i}`
      this.monthOptions.push(month)
    }
    for (let day = 1; day<= 31; day++) {
      this.dayOptions.push(day)
    }

    this.countryOptions = countryData;
    this.currencyOptions = currencyData;
    // this.subdivisions = subdivisionData;

    //todo add optional fields
    this.minRegForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      username: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(12),this.noSpaceValidator]],

      password: ['', [Validators.required, Validators.minLength(8), this.noSpaceValidator]],
      birthYear: ['', [Validators.required]],
      birthMonth: ['', [Validators.required]],
      birthDay: ['', [Validators.required]],
      // phone: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15), Validators.pattern('[0-9]*')]],
      // address: ['', [Validators.required, this.notOnlySpaceValidator]],
      // address2: [''],
      // city: ['', [Validators.required, this.notOnlySpaceValidator]],
      // province: [''],
      // zip: ['', [Validators.required,this.notOnlySpaceValidator]], //??3-10characters
      country: ['', [Validators.required]],
      currency: ['', [Validators.required]],
      // optionalFields: this.formBuilder.group({
      //   fname: [''],
      //   lname: [''],
      // })
      fname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), this.notOnlySpaceValidator]],
      lname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), this.notOnlySpaceValidator]],
    }, {
      // validators: [this.provinceOptionalValidator, this.ageValidator]
      validators: [this.ageValidator]
    });

  }

  ngOnInit(){
    this.formSubs?.unsubscribe();
    this.formSubs = this.minRegForm.valueChanges.subscribe( values => {
      //reset day field if year or month value changes
      if (values.birthYear || values.birthMonth){
        const year = +values.birthYear;
        const month = +values.birthMonth;

        if (year && month && this.previousBirthYear && this.previousBirthMonth && (year !== this.previousBirthYear || month !== this.previousBirthMonth)){
          const daysInMonth = new Date(year, month, 0).getDate();
          if (values.birthDay){
            this.minRegForm.patchValue({ birthDay: '' });
          }
          this.dayOptions = [];
          for (let day = 1; day<= daysInMonth; day++) {
            this.dayOptions.push(day)
          }
        }

        this.previousBirthYear = +year;
        this.previousBirthMonth = +month;
      }

      //filtering provinceOptions if countryValue changes
      // if (values.country && values.country !== this.previousCountry){
      //   const provinces = this.subdivisions.filter(province => province.country_code === values.country)
      //   this.provinceOptions = provinces.map(p=>{
      //     return {
      //       name: p.subdivision_name,
      //       code: p.code
      //     }
      //   })
      //   this.previousCountry = values.country;
      //   // if(this.regObject && this.regObject.details.country !== values.country){
      //   //   this.regStep2Form.patchValue({
      //   //     province: ""
      //   //   })
      //   // }
      //
      //   // Trigger validation whenever the country changes (provinceValidator)
      //   this.minRegForm.updateValueAndValidity();
      // }

    })

  // only needed if we want to use regObject to store regData
  //   // this.regSubs?.unsubscribe();
  //   // this.regSubs = this.regService.regData.subscribe(regData => {
  //   //   this.regObject = regData;
  //   //   if (regData){
  //   //     this.minRegForm.patchValue({
  //   //       email: regData.email,
  //   //       username: regData.username,
  //   //       fname: regData.details.fname ?? "",
  //   //       lname: regData.details.lname ?? "",
  //   //       birthYear: regData.details.birthDate ? regData.details.birthDate.split('-')[0] : "",
  //   //       birthMonth: regData.details.birthDate ? regData.details.birthDate.split('-')[1] : "",
  //   //       birthDay: regData.details.birthDate ? this.getBirthDay(regData.details.birthDate) : "",
  //   //     })
  //   //   }
  //     //reset regSubmit
  //     // this.regSubmit = false;
  //   // })

  }

  submitForm() {
    this.regSubmit = true;
    if (this.minRegForm.valid) {
      //set locale - not required but we send it
      let selectedLang = 'en_US'
      const currentLang = this.translate.currentLang;
      if (currentLang){
        if (currentLang !== 'en'){
          selectedLang = `${currentLang}_${currentLang.toUpperCase()}`
        }
      } else {
        if (navigator.language) {
          const lang = navigator.language.split("-")[0]
          const supportedLanguages = ['en', 'es', 'de', 'fr', 'pt', 'it']
          if (supportedLanguages.includes(lang) && lang !=='en'){
            selectedLang = `${lang}_${lang.toUpperCase()}`
          }
        }
      }
      //first step of registration (create method to get the token)
      const regStep1Data =  {
        email: this.minRegForm.value.email,
        username: this.minRegForm.value.username,
        locale: selectedLang
      }

      this.isLoading = true;

      this.regService.create(regStep1Data).subscribe({
        next: ( response ) => {
          // console.log("Response from create:", response); //result with the regToken, saved in regService

          // second step of registration (addDetails method)
          const regStep2Data: DetailsMapModel =  {
            fname: this.minRegForm.value.fname,
            lname: this.minRegForm.value.lname,
            password: this.minRegForm.value.password,
            birthDate: `${this.minRegForm.value.birthYear}-${this.minRegForm.value.birthMonth}-${this.minRegForm.value.birthDay < 10 ? '0'+ this.minRegForm.value.birthDay : this.minRegForm.value.birthDay}`,
            country: this.minRegForm.value.country,
            currency: this.minRegForm.value.currency
          }

          this.regService.addDetails(regStep2Data).subscribe({
            next: ( response ) => {
              // console.log("response from addDetails:", response); //result is empty = has no errors in validated data

              //if OK -> (save data to RegData BS?), navigate to step 2
              this.isLoading = false;
              this.regSubmit = false;
              //maybe save it in regObject - ???
              // const regDataToSave: RegdataModel = {
                  //               ...regStep1Data,
                  //               details: {
                  //                 // ...this.regObject?.details, //this wont be saved as this will be a new registration on the server
                  //                 fname: this.minRegForm.value.fname,
                  //                 lname: this.minRegForm.value.lname,
                  //                 birthDate: `${this.minRegForm.value.birthYear}-${this.minRegForm.value.birthMonth}-${this.minRegForm.value.birthDay < 10 ? '0'+ this.minRegForm.value.birthDay : this.minRegForm.value.birthDay}`,
                  //               }
                  //             }
                  //             // console.log("sent to service from step1:", regDataToSave);
                  //             this.regService.saveData(regDataToSave)
                  //             this.regService.setStep(2)


              this.currentStep = 'terms' //so html will show the terms section

              this.login = regStep1Data.username;
              this.pw = regStep2Data.password!;

            },
            error: (err) => {
              //errors from addDetails method for birthDate, country, currency, pw
              this.isLoading = false;

              //invalid token
              if (err.error.message === 'Could not authorize request.' || err.status === 401){
                this.toastr.error(`${this.translate.instant('REGISTER.TOASTR_TOKEN_ERROR_MESSAGE')}`, this.translate.instant('REGISTER.TOASTR_TOKEN_ERROR_H1'), {toastClass: 'ngx-toastr yourclass'})
              }

              if (err.error && err.error.data){
                for (const key in err.error.data) {
                  if (err.error.data.hasOwnProperty(key)) {
                    let propName = key.split(".")[1]
                    //set invalid fields invalid
                    if (this.minRegForm.controls[propName]) {
                      const formControlWithError = this.minRegForm.get(propName);
                      if (formControlWithError){
                        formControlWithError.setErrors({validationErrorFromServer: err.error.data[key].message})
                      }
                    } else if (propName === 'birthDate'){
                      const birthYear = this.minRegForm.get('birthYear');
                      const birthMonth = this.minRegForm.get('birthMonth');
                      const birthDay = this.minRegForm.get('birthDay');
                      birthYear?.setErrors({validationErrorFromServer: 'invalid birthDate'})
                      birthMonth?.setErrors({validationErrorFromServer: 'invalid birthDate'})
                      birthDay?.setErrors({validationErrorFromServer: 'invalid birthDate'})
                    }
                    //warn user about the error
                    this.toastr.error(`${err.error.data[key].message}`, `${err.error.message}`, {toastClass: 'ngx-toastr yourclass'})
                  }
                }
              } else {
                //other errors
                if (err.error.message){
                  this.toastr.error( err.error.message, `Registration error`, {toastClass: 'ngx-toastr yourclass'})
                } else {
                  const message = err.message ? err.message : this.translate.instant('REGISTER.TOASTR_UNKNOWN_ERROR_H1')
                  this.toastr.error( message, `${err.status ? err.status : ""} Error`, {toastClass: 'ngx-toastr yourclass'})
                }
              }

            }
          })
        },
        error: (err) => {
          //error from create method for email and username
          this.isLoading = false;

          if(err.error && err.error.data){
            //normal errors from rival
            for (const key in err.error.data) {
              if (err.error.data.hasOwnProperty(key)) {
                //set invalid fields invalid
                if (this.minRegForm.controls[key]) {
                  const formControlWithError = this.minRegForm.get(key);
                  if (formControlWithError){
                    formControlWithError.setErrors({validationErrorFromServer: err.error.data[key].message})
                  }
                }
                //warn user about the error
                this.toastr.error(`${err.error.data[key].message}`, `${err.error.message}`, {toastClass: 'ngx-toastr yourclass'})
              }
            }

            //implement on GP brands - todo when we turn on GP min reg
            // if (err.status === 400){
            //   //bad request on gamingPodium (already existing email/username) - todo later: translation of error messages
            //   if(err.error && err.error.jsonrpc_err && err.error.jsonrpc_err.message){
            //     if (err.error.jsonrpc_err.message.includes('email')){
            //       this.minRegForm.controls['email'].setErrors({invalid: true})
            //     }
            //     if (err.error.jsonrpc_err.message.includes('login')){
            //       this.minRegForm.controls['username'].setErrors({invalid: true})
            //     }
            //   }
            //   //warn user about the error
            //   this.toastr.error(`${err.error.jsonrpc_err.message}`, 'Validation error', {toastClass: 'ngx-toastr yourclass'})
            // }

          } else if (err.error.message){
            this.toastr.error( err.error.message, 'Registration error', {toastClass: 'ngx-toastr yourclass'})
          } else {
            const message = err.message ? err.message : this.translate.instant('REGISTER.TOASTR_UNKNOWN_ERROR_H1')
            this.toastr.error( message, `${err.status ? err.status : ""} Error`, {toastClass: 'ngx-toastr yourclass'})
          }
        }
      })

    }
  }

  finalizeRegistration(){
    this.regSubmit = true;
    if (this.agreeTerms.value){
      this.isLoading = true;

      //send event to GA
      this.gaService.event('register_submit', undefined, undefined, undefined, undefined,{...this.trackingService.getAffiliateOptions() });
      //adding tracking
      const trackingInfo:  {bannerId?: number, tracker?: string}  = {}
      const btag = this.trackingService.getBannerTag();
      if (btag){
        trackingInfo.bannerId = +btag
      }
      const tracker = this.trackingService.getTracker();
      if (tracker){
        trackingInfo.tracker = tracker
      }

      this.regService.finalize(trackingInfo).subscribe({
        next: ( response ) => {
          if('result' in response){
            if('warning' in response.result){
              console.log(response.result.warning); //result has empty warnings array
            }
          }

          this.minRegForm.reset();
          this.minRegForm.patchValue({ birthYear: '' , birthMonth: '', birthDay: '', country: '', currency: ''}); //reset dropdowns' value
          this.regSubmit = false;
          this.agreeTerms.reset();

          //if OK -> login user and toastr success + close modal
          if (this.login && this.pw){
            //send event to GA
            this.gaService.event('register_complete', undefined, undefined, undefined, undefined,{user_id: this.login, ...this.trackingService.getAffiliateOptions() });

            const loginData =  {
              username: this.login,
              password: this.pw,
              mode: 'real',
            }

            this.authService.login(loginData).subscribe({
              next: ( response ) => {
                // console.log(response);
                this.isLoading = false;
                this.toastr.success(this.translate.instant('REGISTER.TOASTR_SUCCESS_MESSAGE',{username: this.login}), this.translate.instant('REGISTER.TOASTR_SUCCESS_H1'), {toastClass: 'ngx-toastr yourclass'});

                this.currentStep = 'form';
                this.closeModal();
                this.regService.resetRegSession();

              },
              error: (err) => {
                // console.error(err)
                this.isLoading = false;
                //TODO - some nice toastr error message if log in failes for any reason + handle that case
                this.toastr.error(`${err.message}`, this.translate.instant('REGISTER.TOASTR_UNKNOWN_ERROR_H1'), {toastClass: 'ngx-toastr yourclass'})
              }
            })
          }

        },
        error: (err) => {
          this.isLoading = false;
          this.minRegForm.reset();
          this.minRegForm.patchValue({ birthYear: '' , birthMonth: '', birthDay: '', country: '', currency: ''}); //reset dropdowns' value
          this.regSubmit = false;
          this.agreeTerms.reset();
          this.currentStep = 'form'


          //send event to GA
          this.gaService.event('register_error', undefined, undefined, undefined, undefined, {...this.trackingService.getAffiliateOptions()});

          //invalid token
          if (err.error.message === 'Could not authorize request.' || err.status === 401) {
            this.toastr.error(`${this.translate.instant('REGISTER.TOASTR_TOKEN_ERROR_MESSAGE')}`, this.translate.instant('REGISTER.TOASTR_TOKEN_ERROR_H1'), {toastClass: 'ngx-toastr yourclass'})
          } else {
            //other errors
            let errorMessage: string;

            //user tries to register from a blocked location - should use VPN
            if (err.error.data && err.error.data.country) {
              errorMessage = err.error.data.country.message;
              if (errorMessage) {
                this.toastr.error(`${errorMessage}`, `${err.error.message}`, {toastClass: 'ngx-toastr yourclass'})
              }
            } else {
              //other errors - validation errors from finalize method
              if (err.error && err.error.data) {
                //means that error comes from server in 200 ok code
                for (const key in err.error.data) {
                  if (err.error.data.hasOwnProperty(key)) {
                    this.toastr.error(`${err.error.data[key].message}`, `${err.error.message}`, {toastClass: 'ngx-toastr yourclass'})
                  }
                }
              } else if (err.error.message){
                this.toastr.error( err.error.message, 'Registration error', {toastClass: 'ngx-toastr yourclass'})
              } else {
                const message = err.message ? err.message : this.translate.instant('REGISTER.TOASTR_UNKNOWN_ERROR_H1')
                this.toastr.error( message, `${err.status ? err.status : ""} Error`, {toastClass: 'ngx-toastr yourclass'})
              }
            }

          }
        }
      })


    }


  }

  //Hide/show password
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  goToPrevStep(){
    this.currentStep = 'form';
    this.agreeTerms.reset();
  }

  closeModal(){
    this.modalService.close('minSignUpModal')
  }

  openLoginModal(){
    this.closeModal();
    this.modalService.open('signInModal');
  }

  // toggleOptionalFields() {
  //   console.log(this.showOptionalFields);
  //   this.setOptionalFieldValidators();
  // }
  // setOptionalFieldValidators() {
  //   const fnameControl = this.optionalFields.get('fname');
  //   const lnameControl = this.optionalFields.get('lname');
  //
  //   if (this.showOptionalFields && fnameControl?.dirty) {
  //     // TODO this validation should be optional per field
  //     fnameControl?.setValidators([Validators.minLength(2), Validators.maxLength(50), this.notOnlySpaceValidator]);
  //     lnameControl?.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(50), this.notOnlySpaceValidator]);
  //   } else {
  //     fnameControl?.clearValidators();
  //     lnameControl?.clearValidators();
  //   }
  //
  //   // Update the validity of the controls
  //   fnameControl?.updateValueAndValidity();
  //   lnameControl?.updateValueAndValidity();
  // }


  get regForm() {
    return this.minRegForm.controls;
  }

  // protected readonly FormGroup = FormGroup; todo find out if this is needed for optional fields?
  // get optionalFields(): FormGroup {
    // return this.minRegForm.get('optionalFields') as FormGroup;
  // }

  noSpaceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const hasSpace = control.value ? control.value.includes(" ") : false;
    return hasSpace ? {noSpace : true} : null;
  }

  notOnlySpaceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const onlySpace = !control.value || !control.value.trim();
    return onlySpace ? { onlySpaces: true } : null;
  }

  ageValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    //user has to be 18+
    const birthYear = control.get('birthYear')?.value;
    const birthMonth = control.get('birthMonth')?.value;
    const birthDay = control.get('birthDay')?.value;

    if (!birthYear || !birthMonth || !birthDay) {
      return null; // No value to validate
    }

    const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    return (age > this.minimalAge || (age === this.minimalAge && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) ? null : { ageInvalid: true };
  }


  // getBirthDay(birthDate: string){
  //   if (birthDate){
  //     const birthDay = +(birthDate.split("-")[2]);
  //     if (birthDay && birthDay > 0){
  //       return birthDay
  //     }
  //   }
  //   return ""
  // }
  //
  //
  //
  // provinceOptionalValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  //   const country = control.get('country');
  //   const province = control.get('province');
  //   if (!country || !province){
  //     return null
  //   }
  //   //province is required for US and for AU: ISO 3166-2 codes (from data.ts) without country code
  //   //for other countries, any value (null included) is accepted, except empty string
  //   if (country.value === "US" || country.value === "AU"){
  //     province?.setValidators([Validators.required, this.notOnlySpaceValidator])
  //   } else {
  //     province?.clearValidators();
  //   }
  //
  //   return null; // No form-level errors to return
  //
  // }

  ngOnDestroy(){
    this.formSubs?.unsubscribe();
    // this.regSubs?.unsubscribe();
  }


}
